import React, { useState } from "react";

import { EventDto, IEventSummary } from "@eagerdog/interfaces";

import { toast } from "src/components/Toast/ToastManager";
import Button from "src/components/Button/Button";
import { apiService } from "src/services/api.service";
import { requestShareToFeed } from "src/routes/Discover/Feed/ShareToFeed/shareToFeedPrompt";

import "./PublishEventModal.scss";
import Dropdown, { IOption } from "../Dropdown/Dropdown";
import date from "../../assets/icons/date.svg";
import DatePick from "../DatePick/DatePick";
import moment from "moment-timezone";
import { Constants } from "@eagerdog/constants";
import { AxiosError } from "axios";

interface IProps {
  toggle: () => void,
  afterUpdate?: () => void,
  event?: IEventSummary
}

const PublishEventModal: React.FC<IProps> = (props) => {
  const [publishOption, setPublishOption] = useState<IOption>(
    { value: "Immediately", "id": "Immediately" }
  );

  const [publishDate, setPublishDate] = useState(
    new Date(Date.now() + 3600 * 1000 * 24)
  );

  return (
    <div className="Confirm">
      <div>
        <div className="title">Publish Event</div>
        <p>When do you want entries to open for this event?</p>
        <Dropdown value={publishOption} onChange={(e: any, value: IOption) => { setPublishOption(value); }} icon={date} label="Entry Open Date" options={[ { value: "Immediately", id: "Immediately" }, { value: "On a Specific Date", id: "On a Specific Date" } ]} placeholder="Choose a publishing option" />
        <>
          {publishOption.value === "On a Specific Date" && (<DatePick showTimeSelect={true} label="Publish Date" onChange={setPublishDate} value={publishDate} rightText={props?.event?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone}/>)}
        </>
      </div>
      <div className="button-group">
        <Button onClick={() => {
          props.toggle()
        }}>Cancel</Button>
        <Button
          onClick={() => {
            if (props.event) {
              let publishAt
              if (publishOption.value !== "Immediately" && props.event.timezone) {
                publishAt = moment.tz(moment(publishDate).format('YYYY-MM-DD HH:mm'), props.event.timezone).toISOString()
              } else {
                publishAt = new Date()
              }

              const eventFields = { ...(props.event as IEventSummary & Record<string, unknown>) };
              [
                "__v",
                "_id",
                "club",
                "admins",
                "show_types",
                "created_at",
                "updated_at",
                "created_by",
                "updated_by",
                "arm_numbers_config",
                "gate_stewards",
                "hotels",
                "documents",
                "custom_obedience_ring_orders",
              ].forEach((key) => {
                delete eventFields[key];
              });

              const payload = {
                ...eventFields,
                publish_at: publishAt,
                status: publishOption.value === "Immediately" ? Constants.event_status.published : Constants.event_status.upcoming,
              }

              const wasDraft = props.event.status === Constants.event_status.draft;
              apiService.updateEvent(props.event._id, payload as EventDto).then((response) => {
                if (response._id) {
                  props.toggle()
                  if (props.afterUpdate) {
                    props.afterUpdate()
                  }
                  toast.show({
                    title: "Update Event",
                    content: "You've successfully updated your event",
                    duration: 10000,
                    type: "success"
                  });
                  // First time public: offer to customize the feed post.
                  if (wasDraft && response.status !== Constants.event_status.draft) {
                    requestShareToFeed(response);
                  }
                }
              }).catch((e: AxiosError) => {
                toast.show({
                  title: "Publish Event",
                  content: "Unable to publish event",
                  duration: 10000,
                  errorDetails: e,
                  type: "fail",
                });
              });
            }
          }}
        >
          Publish now
        </Button>
      </div>
    </div>
  );
}

export default PublishEventModal;
